import type { FeedbackOut } from "@/api/types";

/** `"${batch}.${version}"`, or `"unknown"` when the item has no complete batch and version. */
export type VersionKey = string;

export type VersionChip = { key: VersionKey; batch?: number; version?: number; count: number };

export function itemKey(f: FeedbackOut): VersionKey {
  return f.batch_number !== null && f.version !== null ? `${f.batch_number}.${f.version}` : "unknown";
}

/** Distinct versions in the list, latest first, with "unknown" last. */
export function versionKeys(items: FeedbackOut[]): VersionChip[] {
  const map = new Map<VersionKey, VersionChip>();
  for (const f of items) {
    const key = itemKey(f);
    const chip = map.get(key);
    if (chip) chip.count += 1;
    else map.set(key, key === "unknown" ? { key, count: 1 } : { key, batch: f.batch_number!, version: f.version!, count: 1 });
  }
  return [...map.values()].sort((a, b) => {
    if (a.batch === undefined) return b.batch === undefined ? 0 : 1;
    if (b.batch === undefined) return -1;
    return b.batch - a.batch || b.version! - a.version!;
  });
}

export function filterByVersion(items: FeedbackOut[], key: VersionKey | null): FeedbackOut[] {
  return key === null ? items : items.filter((f) => itemKey(f) === key);
}
